import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px;
  box-shadow: ${({ theme }) => theme.boxShadows.level3};
  border-radius: 4px;
  width: 360px;
  padding: 12px 16px 16px;
  background-color: var(--white);
  font-size: 12px;
  line-height: 1.33;
  transition: all 0.3s ease;
  will-change: transform, opacity;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${({ type }) =>
      type ? `var(--${type.toLowerCase()}-medium)` : "var(--white)"};
    content: "";
  }

  > div:first-child {
    display: flex;
    align-items: flex-start;

    ${({ type }) =>
      type &&
      css`
        svg path {
          fill: var(--${type.toLowerCase()}-medium);
        }
      `}
  }

  > button {
    position: absolute;
    top: 2px;
    right: 2px;
    border: none;

    ${({ type }) =>
      type &&
      css`
        svg path {
          fill: var(--${type.toLowerCase()}-medium);
        }
      `}

    &:hover {
      border-color: ${({ type }) =>
        type ? `var(--${type.toLowerCase()}-medium)` : "var(--white)"};
      ${({ type }) =>
        type && `background-color: var(--${type.toLowerCase()}-light);`}

      svg path {
        fill: ${({ type }) =>
          type ? `var(--${type.toLowerCase()}-medium)` : "var(--white)"};
      }
    }
  }

  ${({ active }) =>
    active
      ? css`
          transform: translate3d(0, 0, 0);
          opacity: 1;
        `
      : css`
          transform: translate3d(20px, 0, 0);
          opacity: 0;
        `}
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  gap: 8px;

  h4 {
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    ${({ type }) => type && `color: var(--${type.toLowerCase()}-medium);`}
  }
`;
